import { defineComponent, ref, computed } from '@vue/composition-api';
import __vue_component__ from '../../icons/Icon.vue.js';
import { useInputMask } from '../useInputMask.js';
import { useRestrictChars } from '../useRestrictChars.js';

/**
 * @deprecated Use appropriate SdsInput instead, or replace with masking input when it ships
 */
var script = defineComponent({
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        state: {
            type: String,
            required: false,
            default: '',
        },
        variant: {
            type: String,
            required: false,
            default: 'white',
        },
        className: {
            type: String,
            required: false,
            default: '',
        },
        prefix: {
            type: String,
            required: false,
            default: '',
        },
        name: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            required: false,
            default: 'text',
        },
        value: {
            type: String,
            required: false,
            default: '',
        },
        label: {
            type: String,
            required: true,
        },
        iconRight: {
            type: String,
            required: false,
            default: '',
        },
        iconRole: {
            type: String,
            required: false,
            default: 'none',
        },
        iconPressed: {
            type: String,
            required: false,
            default: 'undefined',
        },
        isMessageRight: {
            type: Boolean,
            required: false,
            default: false,
        },
        isMessagePlainText: {
            type: Boolean,
            required: false,
            default: true,
        },
        isInputRestricted: {
            type: Boolean,
            required: false,
            default: true,
        },
        mask: {
            type: Object,
            required: false,
            default: function () { return ({
                pattern: '',
                separators: '',
                operators: {},
                shouldPrefillOnFocus: false,
            }); },
        },
    },
    emits: [
        'focus',
        'blur',
    ],
    setup: function (props, _a) {
        var emit = _a.emit;
        var inputRef = ref(null);
        var applyMask = useInputMask(props.mask.pattern, props.mask.separators, props.mask.operators).applyMask;
        function onFocus(event) {
            if (props.mask.pattern && props.mask.shouldPrefillOnFocus) {
                if (!props.value) {
                    fillWithMaskPattern();
                }
            }
            emit('focus', event);
        }
        function onClick(_event) {
            if (props.mask.pattern && (!props.value || props.value === props.mask.pattern)) {
                setTimeout(function () { var _a; return (_a = inputRef.value) === null || _a === void 0 ? void 0 : _a.setSelectionRange(0, 0); }, 0);
            }
        }
        function fillWithMaskPattern() {
            var defaultPattern = applyMask('', inputRef.value);
            emit('valueChanged', defaultPattern);
            emit('input', defaultPattern);
        }
        function onBlur(_event) {
            emit('blur', props.value);
        }
        function updateValue(event) {
            var rawValue = event.target.value;
            var value = props.mask.pattern && props.type !== 'number' ? applyMask(rawValue, inputRef.value, event.data) : rawValue;
            emit('valueChanged', value);
            emit('input', value);
        }
        function focusInput() {
            var _a;
            (_a = inputRef.value) === null || _a === void 0 ? void 0 : _a.focus();
        }
        function moveCaretToEnd() {
            var _a, _b;
            var el = inputRef.value;
            el === null || el === void 0 ? void 0 : el.setSelectionRange(((_a = el.value) === null || _a === void 0 ? void 0 : _a.length) || 0, ((_b = el.value) === null || _b === void 0 ? void 0 : _b.length) || 0);
        }
        var iconClass = computed(function () {
            var _a;
            return (_a = {
                    'icon-warning_triangle_filled icon--error': props.state === 'error',
                    'icon-check_circle_filled icon--success': props.state === 'success'
                },
                _a[props.iconRight] = props.state !== 'error' && props.state !== 'success' && props.iconRight,
                _a);
        });
        var restrictBeforeInput = useRestrictChars(props.type).restrictBeforeInput;
        return {
            iconClass: iconClass,
            isInputEmpty: computed(function () { var _a; return !((_a = props.value) === null || _a === void 0 ? void 0 : _a.trim()); }),
            showIcon: computed(function () { return props.state === 'error' || props.state === 'success' || props.iconRight; }),
            restrictBeforeInput: props.isInputRestricted ? restrictBeforeInput : function () { return void 0; },
            onFocus: onFocus,
            onBlur: onBlur,
            onClick: onClick,
            updateValue: updateValue,
            inputRef: inputRef,
            // Exported to be callable from outside
            focusInput: focusInput,
            moveCaretToEnd: moveCaretToEnd,
        };
    },
    components: {
        Icon: __vue_component__,
    },
});

export default script;
